import { render, staticRenderFns } from "./nptSettings.vue?vue&type=template&id=177fa7e5&scoped=true"
import script from "./nptSettings.vue?vue&type=script&lang=ts"
export * from "./nptSettings.vue?vue&type=script&lang=ts"
import style0 from "./nptSettings.vue?vue&type=style&index=0&id=177fa7e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177fa7e5",
  null
  
)

export default component.exports